import React from 'react';
import { Outlet } from 'react-router-dom';
import { authenticationService } from '../services/authenticationService.service';
import moment from 'moment';
import Forbidden from "../pages/auth/Forbidden";

export const RequireAuth = () => {
    const currentUser = authenticationService.currentUserValue;
    const now = moment(new Date().toUTCString());

    if (!currentUser) {
        authenticationService.authenticate();
        return null;
    } else if (moment.utc(currentUser.tokenExpiration).isBefore(now)) {
        authenticationService.logout();
        authenticationService.authenticate();
        return null;
    } else {
        return <Outlet />;
    }
};
